module.exports = __webpack_public_path__ + "static/media/5.a177008c.mp3";